import { DestinoMigracao } from '../interfaces/adesao.dto';

/** Família do plano pelo nome (PLATINA|BLACK|OURO); sem família, o nome cru. */
export function familiaDoPlano(nome?: string | null): string {
  const n = (nome ?? '').trim();
  if (!n) return 'atual';
  const m = n.match(/PLATINA|BLACK|OURO/i);
  if (!m) return n;
  const f = m[0].toLowerCase();
  return f.charAt(0).toUpperCase() + f.slice(1);
}

export function textoDoMotivo(motivo: string, nomePlanoAtual?: string | null): string {
  const familia = familiaDoPlano(nomePlanoAtual);
  switch (motivo) {
    case 'origem-bloqueada': return `O plano ${familia} não pode ser migrado.`;
    case 'plano-anual': return `O plano ${familia} anual não pode ser migrado.`;
    case 'sem-destino': return 'Não há planos de upgrade nesta praça.';
    case 'periodo-pendente': return 'Há mensalidade pendente. Regularize antes de migrar.';
    case 'operador-sem-acesso': return 'Seu usuário não tem permissão para vender CartãoSiM.';
    case 'sem-assinatura': return 'Paciente sem assinatura ativa.';
    default: return 'Não foi possível consultar agora.';
  }
}

/** Estimativa; o valor real vem da cobrança criada (o núcleo conta também os retirados). */
export function precoComDependentes(destino: DestinoMigracao, mantidos: number): number {
  const pagos = Math.max(0, mantidos - destino.dependentesGratis);
  return Math.round((destino.opcao.valor + pagos * destino.valorDependente) * 100) / 100;
}

export function excedente(destino: DestinoMigracao, mantidos: number): string | null {
  const max = destino.maxDependentes;
  return mantidos > max ? `O plano permite no máximo ${max} dependentes. Retire ${mantidos - max}.` : null;
}

export interface GrupoMigracao {
  familia: string;
  nome: string;
  resumo: string;
  beneficios: string[];
  mensal: DestinoMigracao | null;
  anual: DestinoMigracao | null;
}

const ORDEM_FAMILIAS = ['platina', 'black', 'ouro'];

/** Um grupo por família (mensal = intervalo 1, anual = 12); repetido da mesma família e ciclo fica o primeiro. */
export function agruparPorFamilia(destinos: DestinoMigracao[]): GrupoMigracao[] {
  const grupos = new Map<string, GrupoMigracao>();
  for (const d of destinos ?? []) {
    let g = grupos.get(d.familia);
    if (!g) {
      g = { familia: d.familia, nome: d.nome, resumo: d.resumo, beneficios: d.beneficios ?? [], mensal: null, anual: null };
      grupos.set(d.familia, g);
    }
    if (d.intervalo === 1 && !g.mensal) g.mensal = d;
    else if (d.intervalo === 12 && !g.anual) g.anual = d;
  }
  const posicao = (f: string) => {
    const i = ORDEM_FAMILIAS.indexOf((f ?? '').toLowerCase());
    return i < 0 ? ORDEM_FAMILIAS.length : i;
  };
  return [...grupos.values()]
    .filter(g => g.mensal || g.anual)
    .sort((a, b) => posicao(a.familia) - posicao(b.familia));
}
